import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_EditAspect = _resolveComponent("EditAspect")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", {
      class: "aspect",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMode = true))
    }, [
      _createElementVNode("p", null, _toDisplayString(_ctx.aspect.description), 1),
      _createElementVNode("h6", null, _toDisplayString(_ctx.aspect.title), 1),
      _createVNode(_component_Icon, {
        name: _ctx.diceIcon,
        class: "aspect__dice"
      }, null, 8, ["name"])
    ]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.editMode,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editMode) = $event)),
      title: _ctx.$t('edit-aspect')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EditAspect, {
          mode: "edit",
          aspect: _ctx.aspect,
          onRemove: _ctx.remove,
          onUpdate: _cache[1] || (_cache[1] = (newAspect) => _ctx.update(newAspect)),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMode = false))
        }, null, 8, ["aspect", "onRemove"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}